<template>
  <div v-if="visible" class="global-preloader">
    <div class="cssload-fond">
      <div class="cssload-container-general">
        <div class="cssload-internal"><div class="cssload-ballcolor cssload-ball_1"></div></div>
        <div class="cssload-internal"><div class="cssload-ballcolor cssload-ball_2"></div></div>
        <div class="cssload-internal"><div class="cssload-ballcolor cssload-ball_3"></div></div>
        <div class="cssload-internal"><div class="cssload-ballcolor cssload-ball_4"></div></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useLoadingStore } from '@/stores/loading';

const loadingStore = useLoadingStore();
const visible = computed(() => loadingStore.isVisible);
</script>

<style scoped>
.global-preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.12);
  pointer-events: auto;
}

.cssload-fond {
  position: relative;
  margin-top: 0;
  animation: fade 0.2s;
}

.cssload-container-general {
  width: 43px;
  height: 43px;
  animation: cssload-animball_two 2s infinite;
}

.cssload-internal {
  width: 43px;
  height: 43px;
  position: absolute;
}

.cssload-ballcolor {
  width: 16px;
  height: 16px;
  border-radius: 50%;
}

.cssload-ball_1,
.cssload-ball_2,
.cssload-ball_3,
.cssload-ball_4 {
  position: absolute;
  animation: cssload-animball_one 2s infinite ease;
}

.cssload-ball_1 {
  background-color: #cb2025;
  top: 0;
  left: 0;
}

.cssload-ball_2 {
  background-color: #f8b334;
  top: 0;
  left: 27px;
}

.cssload-ball_3 {
  background-color: #00a096;
  top: 27px;
  left: 0;
}

.cssload-ball_4 {
  background-color: #97bf0d;
  top: 27px;
  left: 27px;
}

@keyframes cssload-animball_one {
  0% {
    position: absolute;
  }
  50% {
    top: 13.5px;
    left: 13.5px;
    position: absolute;
    opacity: 0.5;
  }
  100% {
    position: absolute;
  }
}

@keyframes cssload-animball_two {
  0% {
    transform: rotate(0deg) scale(0.7);
  }
  50% {
    transform: rotate(360deg) scale(1);
  }
  100% {
    transform: rotate(720deg) scale(0.7);
  }
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
